import { render, staticRenderFns } from "./ExcHeaderNavItem.vue?vue&type=template&id=6ad8600c&scoped=true&"
import script from "./ExcHeaderNavItem.vue?vue&type=script&lang=js&"
export * from "./ExcHeaderNavItem.vue?vue&type=script&lang=js&"
import style0 from "./ExcHeaderNavItem.vue?vue&type=style&index=0&id=6ad8600c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad8600c",
  null
  
)

export default component.exports